export default {
	// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
	data() {
		return {
			actionPerformeds: [
				{
                    name: 'Login',
                    actions: [
                        {name: 'Login', value: 'Login'},
                        {name: 'Logout', value: 'Logout'},
                    ]

                },
                {
                    name: 'User',
                    actions: [
                        {name: 'Add User', value: 'Add User'},
                        {name: 'Update User', value: 'Update User'},
                        {name: 'View User', value: 'View User'},
                        {name: 'Reset User Password', value: 'Reset User Password'},
                        {name: 'Update User Password', value: 'Update User Password'},
                        {name: 'Update User 2FA', value: 'Update User 2FA'},
                        {name: 'Delete User', value: 'Delete User'},
                        {name: 'Import User', value: 'Import User'},
                        {name: 'Export User', value: 'Export User'}
                    ]
                },
                {
                    name: 'Company',
                    actions: [
                        {name: 'Add Company', value: 'Add Company'},
                        {name: 'Update Company', value: 'Update Company'},
                        {name: 'View Company', value: 'View Company'},
                        {name: 'Delete Company', value: 'Delete Company'},
                        {name: 'Import Company', value: 'Import Company'},
                        {name: 'Export Company', value: 'Export Company'}
                    ]
                },
                {
                    name: 'Conso Group',
                    actions: [
                        {name: 'Add Conso Group', value: 'Add Conso Group'},
                        {name: 'Update Conso Group', value: 'Update Conso Group'},
                        {name: 'View Conso Group', value: 'View Conso Group'},
                        {name: 'Delete Conso Group', value: 'Delete Conso Group'},
                        {name: 'Import Conso Group', value: 'Import Conso Group'},
                        {name: 'Export Conso Group', value: 'Export Conso Group'}
                    ]
                },
                {
                    name: 'Purpose',
                    actions: [
                        {name: 'Add Purpose', value: 'Add Purpose'},
                        {name: 'Update Purpose', value: 'Update Purpose'},
                        {name: 'View Purpose', value: 'View Purpose'},
                        {name: 'Delete Purpose', value: 'Delete Purpose'},
                        {name: 'Import Purpose', value: 'Import Purpose'},
                        {name: 'Export Purpose', value: 'Export Purpose'}
                    ]
                },
				{
                    name: 'Account',
                    actions: [
                        {name: 'Add Account', value: 'Add Account'},
                        {name: 'Update Account', value: 'Update Account'},
                        {name: 'View Account', value: 'View Account'},
                        {name: 'Delete Account', value: 'Delete Account'},
                        {name: 'Import Account', value: 'Import Account'},
                        {name: 'Export Account', value: 'Export Account'}
                    ]

                },
                {
                    name: 'Country',
                    actions: [
                        {name: 'Add Country', value: 'Add Country'},
                        {name: 'Update Country', value: 'Update Country'},
                        {name: 'View Country', value: 'View Country'},
                        {name: 'Delete Country', value: 'Delete Country'},
                        {name: 'Import Country', value: 'Import Country'},
                        {name: 'Export Country', value: 'Export Country'}
                    ]
                },
                {
                    name: 'Currency',
                    actions: [
                        {name: 'Add Currency', value: 'Add Currency'},
                        {name: 'Update Currency', value: 'Update Currency'},
                        {name: 'View Currency', value: 'View Currency'},
                        {name: 'Delete Currency', value: 'Delete Currency'},
                        {name: 'Import Currency', value: 'Import Currency'},
                        {name: 'Export Currency', value: 'Export Currency'}
                    ]
                },
                {
                    name: 'Currency Exchange Rate',
                    actions: [
                        {name: 'Add Currency Exchange Rate', value: 'Add Currency Exchange Rate'},
                        {name: 'Update Currency Exchange Rate', value: 'Update Currency Exchange Rate'},
                        {name: 'View Currency Exchange Rate', value: 'View Currency Exchange Rate'},
                        {name: 'Delete Currency Exchange Rate', value: 'Delete Currency Exchange Rate'},
                        {name: 'Import Currency Exchange Rate', value: 'Import Currency Exchange Rate'},
                        {name: 'Export Currency Exchange Rate', value: 'Export Currency Exchange Rate'}
                    ]
                },
                {
                    name: 'Elimination Settings',
                    actions: [
                        {name: 'Add Elimination Setting', value: 'Add Elimination Setting'},
                        {name: 'Update Elimination Setting', value: 'Update Elimination Setting'},
                        {name: 'View Elimination Setting', value: 'View Elimination Setting'},
                        {name: 'Delete Elimination Setting', value: 'Delete Elimination Setting'},
                        {name: 'Import Elimination Setting', value: 'Import Elimination Setting'},
                        {name: 'Export Elimination Setting', value: 'Export Elimination Setting'}
                    ]
                },
                {
                    name: 'Sheet',
                    actions: [
                        {name: 'Add Sheet', value: 'Add Sheet'},
                        {name: 'Update Sheet', value: 'Update Sheet'},
                        {name: 'View Sheet', value: 'View Sheet'},
                        {name: 'Delete Sheet', value: 'Delete Sheet'},
                        {name: 'Import Sheet', value: 'Import Sheet'},
                        {name: 'Export Sheet', value: 'Export Sheet'}
                    ]
                },
                {
                    name: 'Template',
                    actions: [
                        {name: 'Update Template', value: 'Update Template'},
                        {name: 'Publish Template', value: 'Publish Template'},
                        {name: 'Delete Template', value: 'Delete Template'},
                    ]
                },
                {
                    name: 'Setting',
                    actions: [
                        {name: 'Update Setting', value: 'Update Setting'},
                    ]
                },
                {
                    name:'Financial Report',
                    actions: [
                        {name: 'Add Financial Report', value: 'Add Financial Report'},
                        {name: 'Update Financial Report', value: 'Update Financial Report'},
                        {name: 'Submit Financial Report', value: 'Submit Financial Report'},
                        {name: 'Finalise Financial Report', value: 'Finalise Financial Report'},
                        {name: 'View Financial Report', value: 'View Financial Report'},
                        {name: 'Delete Financial Report', value: 'Delete Financial Report'},
                        {name: 'Load Financial Report', value: 'Load Financial Report'},
                        {name: 'Reset Financial Report', value: 'Reset Financial Report'},
                    ]
                },
                {
                    name: 'Financial Report Sheet',
                    actions: [
                        {name: 'Update Financial Report Sheet', value: 'Update Financial Report Sheet'},
                        {name: 'View Financial Report Sheet', value: 'View Financial Report Sheet'},
                    ]
                },
                {
                    name: 'Financial Report Submission',
                    actions: [
                        {name: 'Validate Submitted Financial Report', value: 'Validate Submitted Financial Report'},
                        {name: 'Accept Submitted Financial Report', value: 'Accept Submitted FinancialReport'},
                        {name: 'Reject Submitted Financial Report', value: 'Reject Submitted Financial Report'},
                    ]
                },
                {
                    name: 'Journal',
                    actions: [
                        {name: 'Add Journal', value: 'Add Journal'},
                        {name: 'Update Journal', value: 'Update Journal'},
                        {name: 'View Journal', value: 'View Journal'},
                        {name: 'Delete Journal', value: 'Delete Journal'},
                    ]
                },
                {
                    name: 'Journal Entity',
                    actions: [
                        {name: 'Add Journal Entity', value: 'Add Journal Entity'},
                        {name: 'Update Journal Entity', value: 'Update Journal Entity'},
                        {name: 'View Journal Entity', value: 'View Journal Entity'},
                        {name: 'Delete Journal Entity', value: 'Delete Journal Entity'},
                    ]
                },
                {
                    name: 'Report',
                    actions: [
                        {name: 'View Report', value: 'View Report'},
                        {name: 'Generate Report', value: 'Generate Report'},
                    ]
                }
			],
		}
	}
};